import React from 'react';
import { withRouter } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';

//COMPONENTS
import { Button, Column, Content, IBox, Row, Select, Title } from '../inspinia';

//MASK
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';
import { getToken } from '../../store/auth';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import InputMask from 'react-input-mask';
import CircularProgress from '@material-ui/core/CircularProgress';
import { TurnedInRounded } from '@material-ui/icons';

class EnvioUnico extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            form: this.formInitialState(),
            file: null,
            alerta: withReactContent(Swal),

            comboEmpresa:
            {
                results: undefined
            },
            comboTipoListaContato:
            {
                results: undefined
            },
            opcoes: {
                results: [
                    { value: 'NULL', label: 'Nenhum' },
                    { value: 'S', label: 'SMS' },
                    { value: 'W', label: 'Whatsapp' }
                ]
            },
            comboNomeCampanhas:
            {
                results: undefined
            },
            campanhaValues:
            {
                value: "",
                label: ""
            },
            loadingCampanha: false,
            disableSenhaCampos: false,
            comboNomeCampanhasAutoComplete: [],

            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
        }
        this.handleChange = this.handleChange.bind(this);
        this.onNomeCampanhaChange = this.onNomeCampanhaChange.bind(this);
        this.onChangeFile = this.onChangeFile.bind(this);
        this.handleEnviarClick = this.handleEnviarClick.bind(this);
        this.handleEmpresaChange = this.handleEmpresaChange.bind(this);
        this.handleTipoEnvioChange = this.handleTipoEnvioChange.bind(this);
        this.handleSenhaPdfChange = this.handleSenhaPdfChange.bind(this);
        this.validateForm = this.validateForm.bind(this);
        this.confirmSendWithoutAttachment = this.confirmSendWithoutAttachment.bind(this);
        this.handleLimparClick = this.handleLimparClick.bind(this);
    }

    formInitialState() {
        return {
            nome: "",
            empresa: {},
            tipoEnvio: "",
            file: "",
            textoSms: "",
            email: "",
            telefone: "",
            rotina: "",
            data1: "",
            data2: "",
            data3: "",
            cpfCnpj: "",
            uc: "",
            protocolo: "",
            data1Disabled: true,
            data2Disabled: true,
            data3Disabled: true,
            emailDisabled: true,
            telefoneDisabled: true,
            pdfSemSenha: false
        };
    }

    componentDidMount() {
        this.loadComboEmpresa();
        this.loadTipoListaEnvio();
    }

    LoadComboNomeCampanhas(empresa) {
        const self = this;
        if (empresa === "") {
            self.setState(
                {
                    campanhaValues: { value: "", label: "" },
                    comboNomeCampanhasAutoComplete: []
                }
            );

            return;
        }

        const url = `${c.API_BASE_URL}/toi-campanhas-por-empresa/${empresa}`;
        const options =
        {
            method: 'GET'
            , headers: { 'Content-Type': 'application/json' }
        };

        self.setState(
            {
                loadingCampanha: true,
                campanhaValues: { value: "", label: "" },
                comboNomeCampanhasAutoComplete: []
            }
        );

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loadingCampanha: false, comboNomeCampanhas: response, comboNomeCampanhasAutoComplete: response.results });
        });
    }

    loadTipoListaEnvio() {
        const url = `${c.API_BASE_URL}/combo-tipo-lista-envio`;
        const options = { method: 'GET', headers: { 'Content-Type': 'application/json' } };

        callApi(url, options, response => {
            const results = response.results.map(result => ({ value: result.id, label: result.descricao }));
            this.setState({ ...this.state, comboTipoListaContato: { results } });
        });
    }


    loadComboEmpresa() {
        const self = this;
        const data = JSON.stringify({
            'id_produto': null
        });
        const url = `${c.API_BASE_URL}/company-user`;
        const options = {
            method: 'POST',
            body: data
        };

        callApi(url, options, function (response) {
            self.setState({ ...self.state, comboEmpresa: response });
        });
    }

    handleEmpresaChange(e) {
        const form = this.state.form;
        const self = this;

        if (e.target.value === "Selecione...") {
            self.setState({
                ...self.state, form: {
                    ...form,
                    empresa: {
                        id: ""
                    }
                }
            });
            self.LoadComboNomeCampanhas("");
        } else {
            self.setState({
                ...self.state, form: {
                    ...form,
                    empresa: {
                        id: e.target.value
                    }
                }
            });

            self.LoadComboNomeCampanhas(e.target.value);
        }
    }

    handleLimparClick() {
        if (this.state.loading) {
            return;
        }
        this.setState({
            ...this.state,
            form: this.formInitialState(),
            file: null,
            campanhaValues: {
                value: '',
                label: ''
            },
            disableSenhaCampos: false
        });

        const select = document.querySelector('select');
        if (select) select.value = "Prioridade de envio";
        const file = document.querySelector('.file');
        if (file) file.value = '';
        const customFileLabel = document.getElementsByClassName('custom-file-label').item(0);
        if (customFileLabel) {
            customFileLabel.textContent = "Selecione o arquivo";
        }
    }

    handleTipoEnvioChange(e) {
        const form = this.state.form;

        if (e.target.value === "Selecione...") {
            this.setState({ form: { ...form, [e.target.name]: "" } });
        } else {
            let tipoEnvio = e.target.value;
            let emailDisabled = true;
            let telefoneDisabled = true;

            if (tipoEnvio === "1" || tipoEnvio === "3" || tipoEnvio === "4" || tipoEnvio === "6" || tipoEnvio === "7") {
                emailDisabled = false;
            }

            if (tipoEnvio === "2" || tipoEnvio === "3" || tipoEnvio === "4" || tipoEnvio === "5" || tipoEnvio === "6" || tipoEnvio === "7") {
                telefoneDisabled = false;
            }

            this.setState({
                form: {
                    ...form,
                    [e.target.name]: e.target.value,
                    email: emailDisabled ? "" : form.email,
                    telefone: telefoneDisabled ? "" : form.telefone,
                    emailDisabled: emailDisabled,
                    telefoneDisabled: telefoneDisabled
                }
            });
        }
    }

    handleSenhaPdfChange(e) {
        const form = this.state.form;

        let checked = e.target.checked;
        this.setState({
            ...this.state,
            form: {
                ...form,
                pdfSemSenha: checked
            }
        });
    }

    handleChange(e) {
        if (e.target.name === "empresa") {
            this.handleEmpresaChange(e);
        } else if (e.target.name === "tipoEnvio") {
            this.handleTipoEnvioChange(e);
        } else if (e.target.name === "pdfSemSenha") {
            this.handleSenhaPdfChange(e);
        } else {
            const form = this.state.form;
            this.setState({ form: { ...form, [e.target.name]: e.target.value } });
        }
    }

    onNomeCampanhaChange = (event, values) => {
        const form = this.state.form;
        let campanhaCombo = '';

        if (values) {
            campanhaCombo = values.value;
        }

        const isCampanha28 = campanhaCombo === 28;

        this.setState(prevState => ({
            ...prevState,
            form: {
                ...form,
                'campanha': campanhaCombo,
                data1: isCampanha28 ? form.data1 : "",
                data2: isCampanha28 ? form.data2 : "",
                data3: isCampanha28 ? form.data3 : "",
                data1Disabled: isCampanha28 ? false : true,
                data2Disabled: isCampanha28 ? false : true,
                data3Disabled: isCampanha28 ? false : true,
            },
            campanhaValues: values,
        }));
    }

    onChangeFile(e) {
        const form = this.state.form;
        const file = e.target.files[0];
        form.file = file;
        this.setState({ file });

        const fileLabel = document.getElementsByClassName('custom-file-label').item(0);

        if (file) {
                
            const validExtensions = ['pdf', 'zip', '7z'];
            const fileExtension = file.name.split('.').pop().toLowerCase();

            if (!validExtensions.includes(fileExtension)) {
                form.file = null;
                this.setState({ file: null });
                fileLabel.textContent = "Selecione o arquivo";
                c.TOASTER_ERROR("Formato do arquivo inválido.");
                return;
            }

            if (file.size > 20 * 1024 * 1024) {
                form.file = null;
                this.setState({ file: null });
                fileLabel.textContent = "Selecione o arquivo";
                c.TOASTER_ERROR("O arquivo não deve ser maior que 20MB.");
                return;
            }

            const disableCampos = (fileExtension === 'zip' || fileExtension === '7z');
            this.setState({
                disableSenhaCampos: disableCampos,
                form: {
                    ...form,
                    cpfCnpj: disableCampos ? "" : form.cpfCnpj,
                    pdfSemSenha: disableCampos ? false : form.pdfSemSenha,
                }
            });

            fileLabel.textContent = file.name;
        } else {
            fileLabel.textContent = "Selecione o arquivo";
        }
    }

    handleEnviarClick() {
        const self = this;
        const state = self.state;

        if (state.loading) return;

        this.setState({ ...this.state, loading: true })

        let validationMessage = this.validateForm();
        if (validationMessage) {
            c.TOASTER_ERROR_LINES(validationMessage);
            this.setState({ ...this.state, loading: false })
        } else {
            this.sendPostRequest();
        }
    }

    sendPostRequest() {
        const state = this.state;

        if (state.loading) return;

        const url = `${c.API_BASE_URL}/toi-validate/mailing-unico`;
        const _token = c.AUTH_HEADER(getToken());

        let data = this.getFormData();

        const options = {
            method: 'POST',
            body: data,
            headers: { 'Authorization': _token }
        };

        this.setState({ ...this.state, loading: true })

        fetch(url, options).then(async (response) => {
            response.json().then(resp => {
                if (resp.status === 200) {
                    c.TOASTER_SUCCESS(resp.message);
                    this.setState(
                        {
                            ...this.state,
                            loading: false,
                            form:
                            {
                                nome: "",
                                empresa: "",
                                tipoEnvio: "",
                                file: "",
                                textoSms: "",
                                email: "",
                                telefone: "",
                                rotina: "",
                                cpfCnpj: "",
                                uc: "",
                                protocolo: "",
                                emailDisabled: true,
                                telefoneDisabled: true,
                                pdfSemSenha: false,
                                data1: "",
                                data1Disabled: true,
                                data2: "",
                                data2Disabled: true,
                                data3: "",
                                data3Disabled: true
                            },
                            campanhaValues:
                            {
                                value: "",
                                label: ""
                            },
                            file: null,
                            loadingCampanha: false,
                            disableSenhaCampos: false
                        }
                    );

                    const select = document.querySelector('select');
                    select.value = "Selecione...";
                    document.getElementsByClassName('custom-file-label').item(0).textContent = "Selecione o arquivo";
                    const file = document.querySelector('.file');
                    file.value = '';
                } else {
                    this.state.alerta.fire({
                        title: 'Atenção! Erro no preenchimento do formulário.',
                        icon: 'warning',
                        html: resp.message,
                        confirmButtonColor: '#47A789'
                    });
                    this.setState({ ...this.state, loading: false })
                }
            });
        });
    }

    getFormData() {
        const { form, campanhaValues } = this.state;
        const data = new FormData();

        const getFieldValue = (field) => {
            return field === '' ? null : field;
        };

        const appendField = (fieldName, fieldValue) => {
            const value = getFieldValue(fieldValue);
            if (value !== null) {
                data.append(fieldName, value);
            }
        };

        appendField('nome', form.nome);
        appendField('tipoEnvio', form.tipoEnvio);
        appendField('idEmpresa', form.empresa.id);
        appendField('email', form.email);
        appendField('telefone', form.telefone);
        appendField('idCampanha', campanhaValues.value);
        appendField('cpfCnpj', form.cpfCnpj);
        appendField('uc', form.uc);
        appendField('protocolo', form.protocolo);
        appendField('file', form.file);
        appendField('pdfSemSenha', form.pdfSemSenha);
        appendField('opcoes', form.opcoes);
        appendField('data1', form.data1);
        appendField('data2', form.data2);
        appendField('data3', form.data3);

        return data;
    }

    validateForm() {
        const state = this.state;
        const form = state.form;
        let message = "";

        if (!form.nome) {
            message += "Campo 'Nome Cliente' de preenchimento obrigatório.<br>";
        }
        if (!form.tipoEnvio || form.tipoEnvio === "Selecione...") {
            message += "Campo 'Prioridade de envio' de preenchimento obrigatório.<br>";
        }
        if (!form.empresa.id) {
            message += "Campo 'Filial' de preenchimento obrigatório.<br>";
        }
        if (!form.email && !form.emailDisabled) {
            message += "Campo 'Destinatário email' de preenchimento obrigatório.<br>";
        }
        if (!form.telefone && !form.telefoneDisabled) {
            message += "Campo 'Destinatário sms' de preenchimento obrigatório.<br>";
        }
        if (!state.campanhaValues.value) {
            message += "Campo 'Rotina' de preenchimento obrigatório.<br>";
        }
        if ((!form.pdfSemSenha && !form.cpfCnpj) && !this.state.disableSenhaCampos) {
            message += "Campo 'CPF/CNPJ (Senha)' de preenchimento obrigatório ou marque o campo 'Arquivo sem senha?'.<br>";
        }
        if (!form.telefoneDisabled) {
            state.opcoes = 'S';
        }
        if (!form.file && !message) {
            message += "Selecione um arquivo PDF.<br>";
            this.confirmSendWithoutAttachment();
        }

        return message;
    }

    confirmSendWithoutAttachment() {
        this.setState({ ...this.state, loading: true })

        this.state.alerta.fire({
            title: 'Tem certeza que deseja enviar sem anexo?',
            text: 'Essa ação é irreversível!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            confirmButtonColor: '#47A789',
            cancelButtonColor: '#ED5358',
            reverseButtons: true,
            allowOutsideClick: () => !this.state.alerta.isLoading(),
            showLoaderOnConfirm: true,
            backdrop: true,
        }).then((result) => {
            if (result.dismiss === Swal.DismissReason.cancel) {
                this.state.alerta.fire({
                    title: 'Cancelado',
                    text: 'Operação cancelada',
                    icon: 'error',
                    confirmButtonColor: '#47A789'
                })
                this.setState({ ...this.state, loading: false })
            } else {
                this.setState({ ...this.state, loading: false })
                this.sendPostRequest();
            }
        });
    }

    ajustaTextoComboTipoEnvio(combo) {
        if (combo?.results) {
            const opcoes = {
                results: []
            };

            combo.results.map(row => {
                if (row.value && row.label) {
                    let result = {
                        value: row.value,
                        label: row.value + ' - ' + row.label
                    }
                    opcoes.results.push(result);
                }
            });

            return opcoes;
        }

        return combo;
    }

    render() {
        const form = this.state.form;
        const campanhas = this.state.comboNomeCampanhasAutoComplete;

        const isDisabled = this.state.loading;
        const isDisabledCampanha = this.state.loading || this.state.loadingCampanha;

        return (
            <div>
                <Row className="mb-4">
                    <Column>
                        <IBox>
                            <Title>
                                <h2 className="fs-20 fw-600 text-body m-0">Envio único</h2>
                            </Title>
                            <Content>


                                <Row className="form-row">
                                    <div className='form-group col-md-4'>
                                        <label>Nome Cliente</label>
                                        <div>
                                            <input type="text" maxLength='60' name="nome" value={form.nome} onChange={this.handleChange} disabled={isDisabled} className="form-control" />
                                        </div>
                                    </div>
                                    <div className="form-group col-md-4">
                                        <label>Prioridade de envio</label>
                                        <Select name="tipoEnvio" selected={form.tipoEnvio} data={this.ajustaTextoComboTipoEnvio(this.state.comboTipoListaContato)} disabled={isDisabled} onChange={this.handleChange} placeholder="Prioridade de envio" />
                                    </div>
                                    <div className="form-group col-md-4">
                                        <label>Filial</label>
                                        <Select name="empresa" selected={form.empresa.id} data={this.state.comboEmpresa} disabled={isDisabled} onChange={this.handleChange} placeholder="Empresa" />
                                    </div>
                                </Row>

                                <Row className="form-row">
                                    <div className='form-group col-md-4'>
                                        <label>Destinatário email</label>
                                        <div>
                                            <input type='text' maxLength='100' name="email" onChange={this.handleChange} value={form.email} disabled={form.emailDisabled || isDisabled} className="form-control" ></input>
                                        </div>
                                    </div>
                                    <div className='form-group col-md-4'>
                                        <label>Destinatário sms</label>
                                        <div>
                                            <input type='text' minLength='11' maxLength='19' name="telefone" disabled={form.telefoneDisabled || isDisabled} onChange={this.handleChange} onKeyPress={this.handleKeyPress} value={form.telefone} className="form-control" ></input>
                                        </div>
                                    </div>
                                    <div className='form-group col-md-4'>
                                        <label>Rotina:</label>
                                        <Autocomplete
                                            id="combo-campanha"
                                            options={campanhas}
                                            getOptionLabel={(option) => option.label}
                                            style={{ marginTop: -8 }}
                                            onChange={this.onNomeCampanhaChange}
                                            value={this.state.campanhaValues}
                                            disabled={isDisabledCampanha}
                                            getOptionSelected={(option) => option.value}
                                            renderInput={
                                                (params) =>
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                        margin="dense"
                                                    />
                                            }
                                        />
                                    </div>
                                </Row>

                                <Row className="form-row">
                                    <div className="form-group col-md-4">
                                        <label>Data1</label>
                                        <InputMask mask="99/99/9999" name="data1" value={form.data1} disabled={form.data1Disabled || isDisabled} placeholder="___/___/___" onChange={this.handleChange} className="form-control" />
                                    </div>

                                    <div className="form-group col-md-4">
                                        <label>Data2</label>
                                        <InputMask mask="99/99/9999" name="data2" value={form.data2} disabled={form.data2Disabled || isDisabled} placeholder="___/___/___" onChange={this.handleChange} className="form-control" />
                                    </div>

                                    <div className="form-group col-md-4">
                                        <label>Data3</label>
                                        <InputMask mask="99/99/9999" name="data3" value={form.data3} disabled={form.data3Disabled || isDisabled} placeholder="___/___/___" onChange={this.handleChange} className="form-control" />
                                    </div>
                                </Row>

                                <Row className="form-row">
                                    <div className='form-group col-md-4'>
                                        <label>CPF/CNPJ (Senha)</label>
                                        <div>
                                            <input type='text' minLength='5' maxLength='14' name='cpfCnpj' onChange={this.handleChange} disabled={this.state.disableSenhaCampos || isDisabled} value={form.cpfCnpj} className="form-control" ></input>
                                        </div>
                                    </div>
                                    <div className='form-group col-md-4'>
                                        <label>UC</label>
                                        <div>
                                            <input type='text' maxLength='20' name='uc' disabled={isDisabled} onChange={this.handleChange} value={form.uc} className="form-control"></input>
                                        </div>
                                    </div>
                                    <div className='form-group col-md-4'>
                                        <label>Protocolo</label>
                                        <div>
                                            <input type='text' maxLength='20' name='protocolo' disabled={isDisabled} onChange={this.handleChange} value={form.protocolo} className="form-control"></input>
                                        </div>
                                    </div>
                                </Row>

                                <Row className="form-row">
                                    <div className='form-group col-md-4'>
                                        <input type="file" name="file" className="custom-file-input file" id="validatedCustomFile" required value={this.state.arquivo} disabled={isDisabled} onChange={this.onChangeFile} />
                                        <label className="custom-file-label" for="validatedCustomFile">Selecione o arquivo</label>
                                    </div>
                                    <div className="form-group col-md-1" style={{ marginTop: '28xp', marginLeft: "50px" }}>
                                        <Button className="mx-1" onClick={this.handleEnviarClick} width="130px">Enviar</Button>
                                    </div>
                                    <div className="form-group col-md-1" style={{ marginLeft: "70px" }}>
                                        <Button className="mx-1" onClick={this.handleLimparClick} width="130px">Limpar</Button>
                                    </div>
                                    <div div className="form-group col-md-1" style={{ marginTop: '5px', marginLeft: '50px' }}>
                                        {this.state.loading && (
                                            <CircularProgress size={30} thickness={4} color="inherit" variant="indeterminate" />
                                        )}
                                    </div>

                                    <Column size="10" className="px-10">
                                        <input placeholder='pdf com senha'
                                            type='checkbox'
                                            className='form-check-input'
                                            name="pdfSemSenha"
                                            onChange={this.handleChange} checked={form.pdfSemSenha}
                                            disabled={this.state.disableSenhaCampos || isDisabled}
                                            style={{ marginLeft: 0 }}
                                        />
                                        <label for="pdfSemSenha" className='form-check-label' style={{ marginLeft: "1.25rem" }}>Arquivo sem Senha?</label>
                                    </Column>
                                </Row>

                            </Content>
                        </IBox>
                    </Column>
                </Row>
                <Row>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch) {
    return { actions: {} };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EnvioUnico));
